import submenu from './topnav_submenu';

export default {
  header: document.getElementById('topnav'),
  button: document.querySelector('#menu-toggler'),
  submenu: null,
  headerHeight: 0,
  currentScrollPos: 0,
  init() {
    if (!this.header) return;

    this.submenu = [...document.querySelectorAll('.js-topnav-submenu')];

    this.headerHeight = parseInt(
      getComputedStyle(document.body).getPropertyValue('--js-header-height')
    );

    if (this.button) {
      this.button.addEventListener('click', () => {
        this.header.classList.toggle('menu-open');
        this.header.classList.remove('unscrolled');

        if (this.header.classList.contains('menu-open')) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
          submenu.closeAll(true);
        }
      });
    }

    if (submenu) submenu.init();

    window.addEventListener('scroll', () => this.handleScroll(), {
      passive: true,
    });

    this.handleScroll();

    window.addEventListener('resize', () => {
      this.header.classList.remove('menu-open');
      document.body.classList.remove('no-scroll');
      if (submenu) submenu.closeAll(true);
    });
  },

  setSubmenusShrunk(shrunk) {
    this.submenu.forEach((el) => {
      el.classList.toggle('shrunk', shrunk);
    });
  },

  handleScroll() {
    const currentScrollPos =
      window.scrollY || document.documentElement.scrollTop;

    if (submenu) submenu.closeAll();

    if (currentScrollPos > this.headerHeight) {
      if (currentScrollPos >= this.currentScrollPos) {
        this.header.classList.add('shrunk');
        if (submenu) this.setSubmenusShrunk(true);
      }
    } else if (currentScrollPos < this.currentScrollPos) {
      this.header.classList.remove('shrunk');
      if (submenu) this.setSubmenusShrunk(false);
    }

    if (currentScrollPos > 0) {
      this.header.classList.remove('unscrolled');
    } else {
      this.header.classList.add('unscrolled');
    }

    this.currentScrollPos = currentScrollPos;
  },
};
